import { api } from "api/api";

export interface Request {
    code: string;
}
interface ResponseData {
    link: string;
}
interface Response {
    returnCode: number;
    data: ResponseData
}

export async function getOneTimeAuthLink({ code }: Request): Promise<Response> {
    const url = `api/mobile/patient/one/time/link/${code}`;
    const response = await api.get(url);
    return response.data;
}
